import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FloatUtilsDesktop = styled.div`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  .inner-float-utils {
    ${mixin.flex({ direction: 'column' })};
    gap: 8px;

    .btn {
      transition: all 0.3s;

      &.top-btn {
        margin-bottom: -48px;
        opacity: 0;
        visibility: hidden;

        &.active {
          margin-bottom: 0;
          opacity: 1;
          visibility: visible;
        }
      }

      &.bottom-btn {
        margin-top: -42px;
        opacity: 0;
        visibility: hidden;

        &.active {
          margin-top: 8px;
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
`;
